import { createSelector } from '@reduxjs/toolkit';
import { isDefined, isNotDefined } from '@sgme/fp';

import { configApi } from '@/api/config/index.ts';
import type { AppState } from '@/store/store.ts';

// would create a new memoized selector on every call, causing reselect stability warnings.
export const selectCurrenciesQueryResult = configApi.endpoints.currencies.select();

export const selectDataByCurrencyPair = (state: AppState) => {
  return selectCurrenciesQueryResult(state);
};

export const selectIsCurrencyPairInverted = (state: AppState, currencyPair: string | undefined) => {
  const dataByCurrencyPair = selectDataByCurrencyPair(state);
  return (isDefined(currencyPair) && dataByCurrencyPair.data?.dict[currencyPair]?.isInverted) ?? false;
};

export const selectCurrencyPairData = (state: AppState, currencyPair: string | undefined) => {
  if (isNotDefined(currencyPair)) {
    return undefined;
  }

  const { data } = selectDataByCurrencyPair(state);

  if (isNotDefined(data)) {
    return undefined;
  }

  return data.dict[currencyPair];
};

export const selectCurrencyPairPrecision = (state: AppState, currencyPair: string | undefined) => {
  if (isNotDefined(currencyPair)) {
    return 0;
  }

  const { data } = selectDataByCurrencyPair(state);

  if (isNotDefined(data)) {
    return 0;
  }

  return data.dict[currencyPair]?.precision ?? 0;
};

export const selectAllCurrencyPairs = createSelector(selectDataByCurrencyPair, (dataByCurrencyPair) => {
  return dataByCurrencyPair.data?.list ?? [];
});
